import { FaGlobeAmericas } from "react-icons/fa";

const Header = () => {
    return (
      <header className="header">
        <h1>
        <FaGlobeAmericas /> Planet Ghibli
        </h1>
      </header>
    );
  };
  
  export default Header;
  